import styled, { css } from 'styled-components';
import { ReactComponent as Alert } from '../../assets/icons/alert.svg';

interface SelectedProps {
  selected?: boolean;
  haveChildren?: boolean;
  resize?: boolean;
  error?: boolean;
}

export const IconAlert = styled(Alert)`
  width: 25px;
  height: 22px;
  margin-top: 7px;
`;

export const NotPayment = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  margin-top: 16px;

  .alert-icon {
    width: 40px;
    height: 35px;
  }

  .box-notpayment {
    display: flex;
    flex-direction: column;
    margin-left: 30px;
    width: 100%;

    @media screen and (max-width: 960px) {
      .title1,
      .title2 {
        max-width: 248px;
      }
      .title1 {
        margin-bottom: 8px;
      }
    }

    .title1 {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 4px;
      color: ${(props) => props.theme.colors.primaryDark2};
      line-height: 24px;
    }

    .title2 {
      font-size: 16px;
      font-weight: 400;
      color: ${(props) => props.theme.colors.gray};
      line-height: 20px;
    }

    .line {
      width: 100%;
      height: 1px;
      background-color: ${(props) => props.theme.colors.lightGray};
      margin: 24px 0 8px 0;
    }
  }
`;

export const InstallmentCards = styled.div<{}>`
  background: ${(props) => props.theme.colors.white};
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  padding: 12px 40px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;

  .item {
    display: flex;
    flex-direction: column;
  }

  .text {
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 4px;
    line-height: 18px;
  }

  .value {
    font-size: 20px;
    font-weight: 700;
    color: ${(props) => props.theme.colors.primaryDark2};
  }

  .date,
  .originalValue {
    display: flex;
    font-weight: 400;
    font-size: 14px;
    margin-top: 4px;
    align-items: center;

    span {
      padding-top: 3px;
    }
  }

  @media screen and (max-width: 960px) {
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    padding: 20px;

    .item {
      width: 180px;
    }
  }
`;

export const SelectContainer = styled.div<SelectedProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) =>
    `2px solid ${props.selected ? props.theme.colors.primaryDark1 : '#000'}`};
  min-height: 24px;
  min-width: 24px;
  border-radius: 50%;
  align-self: center;
  cursor: pointer;

  ${(props) =>
    props.error &&
    css`
      border: 2px solid ${props.theme.colors.danger};
    `}

  span {
    background: ${(props) =>
      props.selected ? props.theme.colors.primaryDark1 : 'none'};
    align-self: center;
    justify-self: center;
    height: 14px;
    width: 14px;
    border-radius: 50%;

    ${(props) =>
      props.error &&
      css`
        background: ${props.theme.colors.danger};
      `}
  }
`;
